export const toInt = (str: string) => parseInt(str, 10);
